type Fbq = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue: unknown[]
  push: Fbq
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

// PIXEL TEKNIKKLAR 30 (CUENTA 30, Negocio 16), 2026-10-24.
export const META_PIXEL_ID = '1643792570569001'

let initialized = false

export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || initialized) return
  if (!/^\d+$/.test(pixelId)) return
  initialized = true

  if (!window.fbq) {
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue.push(args)
      }
    } as Fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const first = document.getElementsByTagName('script')[0]
    if (first?.parentNode) {
      first.parentNode.insertBefore(script, first)
    } else {
      document.head.appendChild(script)
    }
  }

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}
